<template>
  <div class="side_box diagram">
    <h3 class="content-subtitle">{{ this.title }}</h3>
    <!-- <div class="circle_diagram"></div> -->
    <apexchart
      class="apexchart"
      width="200"
      type="donut"
      :options="chartOptions"
      :series="series"
    ></apexchart>

    <div>
      <div class="name">
        <BaseIcon name="circle" class="icon red" />

        Created:
      </div>
      <div class="number">{{ this.active }}</div>
    </div>
    <div>
      <div class="name">
        <BaseIcon name="circle" class="icon yellow" />
        Finished:
      </div>
      <div class="number">{{ this.finished }}</div>
    </div>
    <div>
      <div class="name">
        <BaseIcon name="circle" class="icon green" />
        Approved:
      </div>
      <div class="number">{{ this.approved }}</div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
  },
  props: {
    height: String,
    finished: { type: Number, default: 2 },
    active: { type: Number, default: 2 },
    approved: { type: Number, default: 2 },
    title: { type: String, default: "total stats" },
  },
  components: {
    BaseIcon,
  },
  data: function () {
    return {
      series: [
        this.active,
        this.finished, 
        this.approved,
        ],
      chartOptions: {
        legend: { show: false },
        dataLabels: { enabled: false },
        tooltip: { enabled: false },
        colors: [
          "#F27C7C",
          "#F5D46C", 
          "#8DCE9E", 
          ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/content.scss";
@import "@/style/components/sideBoxV2.scss";
@import "@/style/components/home.scss";

.side_box {
  max-height: 440px;
}
.side_box {
  width: 250px;
}
.name {
  display: flex;
  flex-direction: row;
  .icon {
    margin-right: 20px;
  }
}
.apexchart {
  display: flex !important;
  justify-content: center !important;
}
</style>
